import { render, staticRenderFns } from "./ExtendOtherNutrientsFluor.vue?vue&type=template&id=60a75055&scoped=true"
import script from "./ExtendOtherNutrientsFluor.vue?vue&type=script&lang=ts"
export * from "./ExtendOtherNutrientsFluor.vue?vue&type=script&lang=ts"
import style0 from "./ExtendOtherNutrientsFluor.vue?vue&type=style&index=0&id=60a75055&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a75055",
  null
  
)

export default component.exports